import React, { ReactNode } from 'react';
import { SsrViewModel } from './ssr-view-model.ts';

export const renderFromSsrViewModel = (viewModel: SsrViewModel): Promise<ReactNode> => {
  switch (viewModel.name) {
    case 'restaurant-detail-page':
      return import(
        '../../features/restaurant-detail-page/patterns/03-templates/restaurant-detail-page/restaurant-detail-page.tsx'
        ).then(({ RestaurantDetailPage }) => <RestaurantDetailPage {...viewModel} />);
    case 'home-page':
      return import(
        '../../features/home-page/patterns/03-templates/home-page/home-page.tsx'
        ).then(({ HomePage }) => <HomePage  {...viewModel} />);
  }
};
